// extracted by mini-css-extract-plugin
export default {"modal-bg":"style_modal-bg__gFfuc","modal-container":"style_modal-container__AXZsr","modal":"style_modal__Pm3cF","popup":"style_popup__B8u2C"};